/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/** netSpace名称长度范围 */
export enum NetSpaceNameRangeE {
    MAX = 255,
    MIN = 1,
}

/** netSpace类型 */
export enum NetSpaceTypeE {
    /** 系统默认 */
    SYSTEM = '1',
    /** 自定义 */
    CUSTOMIZED = '2',
}

/** netSpace成员操作类型 */
export enum NetSpaceOperateModel {
    /** 添加 */
    ADD = 'add',
    /** 移除 */
    REMOVE = 'remove',
}

/** 系统默认netSpace的ID */
export const DEFAULT_NET_SPACE_ID = '0';
